import { useProfiles } from '../hooks/useProfiles';
import { useSupabase } from '../context/SupabaseContext';

import { LoadingSpinner } from './LoadingSpinner';

import styles from './ProfileSwitcher.module.css';

export function ProfileSwitcher() {
  const { profiles, loading } = useProfiles();
  const { selectProfile } = useSupabase();

  if (!loading && profiles.length === 0) {
    return <div className={styles.container}>Aucun profil trouvé dans la base de données.</div>;
  }

  if (loading) {
    return <LoadingSpinner size='lg' fullPage />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.profileGrid}>
        {profiles.map((profile) => (
          <div
            key={profile.id}
            className={styles.profileCard}
            onClick={() => selectProfile(profile)}
          >
            <div className={styles.avatarWrapper}>
              <img
                src={"/assets/images/avatars/"+profile.avatar_url}
                alt={profile.name}
                className={styles.avatarImg}
              />
            </div>
            <span className={styles.name}>{profile.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}